"use client";

import { useEffect } from "react";

import { consoleOutput, createLogger } from "@vllnt/logger";

const logger = createLogger("error-boundary", {
  getLogLevel: () => "info",
  output: consoleOutput,
});

import Link from "next/link";
import { useTranslations } from "next-intl";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("errors.general");

  useEffect(() => {
    logger.error("error-boundary-caught", {
      digest: error.digest,
      error: error.message,
    });
  }, [error]);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="space-y-2">
          <h1 className="text-6xl font-semibold tracking-tight">
            {t("title")}
          </h1>
          <p className="text-xl text-muted-foreground">{t("message")}</p>
        </div>

        <div className="flex gap-4 justify-center">
          <button
            className="inline-flex items-center justify-center rounded-md bg-primary px-8 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
            onClick={reset}
            type="button"
          >
            {t("retry_button")}
          </button>
          <Link
            className="inline-flex items-center justify-center rounded-md border border-input bg-background px-8 py-3 text-sm font-medium hover:bg-accent hover:text-accent-foreground transition-colors"
            href="/"
          >
            {t("home_button")}
          </Link>
        </div>
      </div>
    </div>
  );
}
